module.exports = __webpack_public_path__ + "img/vehicles.39db36ff.png";